import React from "react";

function findEmbeddedLinkEntities(contentBlock, callback, contentState) {
  contentBlock.findEntityRanges(function (character) {
    var entityKey = character.getEntity();
    return entityKey !== null && contentState.getEntity(entityKey).getType() === "EMBEDDED_LINK";
  }, callback);
}

var EmbeddedLinkDecorator = function EmbeddedLinkDecorator(props) {// console.log(
  //   "props embeddlink",
  //   props.contentState.getEntity(props.entityKey).getData()
  // );
};

function findLinkEntities(contentBlock, callback, contentState) {
  contentBlock.findEntityRanges(function (character) {
    var entityKey = character.getEntity();
    return entityKey !== null && contentState.getEntity(entityKey).getType() === "LINK";
  }, callback);
}

var LinkDecorator = function LinkDecorator(props) {
  var _props$contentState$g = props.contentState.getEntity(props.entityKey).getData(),
      url = _props$contentState$g.url;

  return /*#__PURE__*/React.createElement("a", {
    href: url,
    style: {
      color: "blue",
      textDecoration: "underline"
    }
  }, props.children);
};

function findImageEntities(contentBlock, callback, contentState) {
  contentBlock.findEntityRanges(function (character) {
    var entityKey = character.getEntity();
    return entityKey !== null && contentState.getEntity(entityKey).getType() === "IMAGE";
  }, callback);
}

var ImageDecorator = function ImageDecorator(props) {
  var _props$contentState$g2 = props.contentState.getEntity(props.entityKey).getData(),
      height = _props$contentState$g2.height,
      src = _props$contentState$g2.src,
      width = _props$contentState$g2.width;

  return /*#__PURE__*/React.createElement("img", {
    src: src,
    height: height,
    width: width
  });
};

export { findLinkEntities, LinkDecorator, findImageEntities, ImageDecorator, findEmbeddedLinkEntities, EmbeddedLinkDecorator };